import React, { memo } from "react";
import styles from "./customHintMessage.module.scss";

const CustomHintMessage = ({ className, children, message, error = false, ...resp }) =>
    <div className={`${className} ${styles.wrapper}`} {...resp}>
        <span className={error && styles.error}> {message || children} </span>
    </div>

export default memo(CustomHintMessage);
